<template>
  <v-navigation-drawer
    id="app-drawer"
    v-model="inputValue"
    color="navDrawerBackground"
    mobile-breakpoint="lg"
    width="288"
  >
    <v-list class="list-container pb-12 active-list-item-no-overlay">
      <v-list-item @click.stop="titleClick" height="56">
        <v-row class="align-center justify-center">
          <v-col cols="2" class="ml-4">
            <v-avatar size="small" rounded="0">
              <v-img
                style="width: 100%; height: 80%"
                alt="Avatar"
                src="data:image/png;base64,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"
              ></v-img>
            </v-avatar>
          </v-col>
          <v-col>
            <v-list-item-title class="text-h6 font-weight-black pl-2 pb-2">
              PrimeStreet
              <span style="vertical-align: super; font-size: 12px">&#174;</span>
            </v-list-item-title>
          </v-col>
        </v-row>
      </v-list-item>
      <v-divider />
      <template v-for="navItem in navItems">
        <!-- Nav Item With Children -->
        <v-list-group
          v-if="navItem.children"
          v-bind="navItem.active"
          :key="navItem.title"
          class="list-group-no-dividers nav-drawer-list-group pl-4"
        >
          <template v-slot:activator="{ props }">
            <v-list-item
              class="pl-4"
              v-bind="props"
              :title="navItem.title"
              :collapse-icon="navItem.icon"
            >
              <template v-slot:prepend>
                <v-icon :icon="navItem.icon"></v-icon>
              </template>
            </v-list-item>
          </template>
          <v-list-item
            style="justify-content: center"
            v-for="child in navItem.children"
            :key="child.title"
            :to="child.href"
            color="primary"
          >
            <v-list-item-action v-if="child.icon">
              <v-icon>{{ child.icon }}</v-icon>
            </v-list-item-action>
            <v-list-item-title style="font-size: 14px">
              {{ child.title }}
            </v-list-item-title>
          </v-list-item>
        </v-list-group>

        <!--          <v-list-group-->
        <!--            v-if="navItem.children"-->
        <!--            v-bind="navItem.active"-->
        <!--            class="list-group-no-dividers nav-drawer-list-group"-->
        <!--            active-color="primary"-->
        <!--            :key="navItem.title"-->
        <!--          >-->
        <!--            <template v-slot:activator>-->
        <!--              <v-list-item class="mx-4">-->
        <!--                <v-icon :icon="navItem.icon"></v-icon>-->
        <!--              </v-list-item>-->
        <!--              <v-list-item-title v-text="navItem.title" class="subtitle-1" />-->
        <!--            </template>-->
        <!--            <v-list-item-->
        <!--              style="margin-left: 60px; justify-content: center"-->
        <!--              class="mdi-format-font-size-decrease"-->
        <!--              v-for="child in navItem.children"-->
        <!--              :key="child.title"-->
        <!--              :to="child.href"-->
        <!--            >-->
        <!--              <v-list-item-action v-if="child.icon">-->
        <!--                <v-icon>{{ child.icon }}</v-icon>-->
        <!--              </v-list-item-action>-->
        <!--              <v-list-item-title style="font-size: 14px">-->
        <!--                {{ child.title }}-->
        <!--              </v-list-item-title>-->
        <!--            </v-list-item>-->
        <!--          </v-list-group>-->
        <!-- Nav Item Without Children -->

        <!-- weird 'hack' with the :key to keep the ide from complaining -->
        <v-list-item
          v-else
          :key="navItem.title"
          :to="navItem.href"
          :exact="navItem.exact"
          color="primary"
          router
        >
          <v-list-item>
            <template v-slot:prepend>
              <v-icon
                style="justify-content: center"
                :icon="navItem.icon"
              ></v-icon>
            </template>
            <v-list-item-title v-text="navItem.title" class="subtitle-1" />
          </v-list-item>
          <v-spacer></v-spacer>
          <template v-if="navItem.chip && navItem.chip !== ''" v-slot:append>
            <v-chip
              v-if="navItem.title !== 'Marketplace'"
              :color="chipColor(navItem.title)"
              chipTextColor
              >{{ navItem.chip }}</v-chip
            >
            <!-- Use flat variant for Marketplace only per red notification style coloring-->
            <v-chip
              v-else
              variant="flat"
              :color="chipColor(navItem.title)"
              chipTextColor
            >
              {{ navItem.chip }}
            </v-chip>
          </template>
        </v-list-item>
      </template>
    </v-list>

    <v-row class="mx-0 px-4 pt-2 pb-4 fixedBottom">
      <v-col class="pt-0 pb-2">
        <v-row>
          <v-col class="py-2 app-version-header text-center">
            <span>Current App Versions</span>
          </v-col>
        </v-row>
        <v-row class="mt-1">
          <v-col class="py-2 app-version text-center">
            <v-icon small color="white" class="mr-2">fab fa-apple</v-icon>
            <span>iOS: {{ iOSVersion }}</span>
          </v-col>
          <v-col class="py-2 app-version text-center">
            <v-icon small color="white" class="mr-2">fab fa-android</v-icon>
            <span>Android: {{ androidVersion }}</span>
          </v-col>
        </v-row>
        <v-row class="mt-1">
          <v-col class="py-2 app-version-header text-center">
            <span>Have questions?</span>
            <br />
            <span>
              <a v-bind:href="'mailto:' + supportEmail">{{ supportEmail }}</a>
            </span>
          </v-col>
        </v-row>
        <v-row class="mt-0">
          <v-col class="text-center">
            <a
              href="https://www.primestreet.io/terms-and-conditions"
              rel="noopener"
              target="_blank"
              class="terms-nav"
            >
              Terms of Use
            </a>
          </v-col>
          <v-col class="text-center">
            <a
              href="https://www.primestreet.io/privacy-policy"
              rel="noopener"
              target="_blank"
              class="terms-nav"
            >
              Privacy Policy
            </a>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </v-navigation-drawer>
</template>

<script>
import { mapGetters, mapMutations } from "vuex";
import C from "@/utils/constants";
import api from "@/services/api.js";
import { useEventBus } from "@/event-bus/bus";

export default {
  name: "console-nav-drawer",
  data() {
    return {
      viewedMarketplaceCount: 0,
      existentMarketplaceCount: 5,
      eventBus: useEventBus(),
      responsive: false,
      // supportEmail: "brokersupport@primestreet.io",
      iOSVersion: "N/A",
      androidVersion: "N/A",
      lenderNavItems: [
        {
          title: "Overview",
          icon: "fa-solid fa-desktop",
          href: "/console",
          exact: true,
          roles: [
            C.ROLE.ADMIN,
            C.ROLE.AGENT_ENGAGEMENT,
            C.ROLE.BROKERAGE_ADMIN,
            C.ROLE.LOAN_OFFICE_ADMIN,
          ],
        },
        {
          title: "My Loan Officers",
          icon: "fas fa-user-group",
          href: "/console/my-loan-officers",
          chip: "",
          roles: [
            C.ROLE.ADMIN,
            C.ROLE.AGENT_ENGAGEMENT,
            C.ROLE.BROKERAGE_ADMIN,
            C.ROLE.LOAN_OFFICE_ADMIN,
          ],
        },
        {
          title: "My Referrals",
          icon: "fa-solid fa-users",
          href: "/console/lender-referrals",
          roles: [
            C.ROLE.ADMIN,
            C.ROLE.AGENT_ENGAGEMENT,
            C.ROLE.BROKERAGE_ADMIN,
            C.ROLE.LOAN_OFFICE_ADMIN,
          ],
        },
      ],
      brokerNavItems: [
        {
          title: "Overview",
          icon: "fa-solid fa-desktop",
          href: "/console",
          exact: true,
          roles: [
            C.ROLE.ADMIN,
            C.ROLE.AGENT_ENGAGEMENT,
            C.ROLE.BROKERAGE_ADMIN,
          ],
        },
        {
          title: "My Agents",
          icon: "fas fa-user-friends",
          href: "/console/my-agents",
          chip: "",
          roles: [
            C.ROLE.ADMIN,
            C.ROLE.AGENT_ENGAGEMENT,
            C.ROLE.BROKERAGE_ADMIN,
          ],
        },
        {
          title: "My Referrals",
          icon: "fas fa-user-plus",
          href: "/console/my-referrals",
          roles: [
            C.ROLE.ADMIN,
            C.ROLE.AGENT_ENGAGEMENT,
            C.ROLE.BROKERAGE_ADMIN,
          ],
        },
        {
          title: "My Leads",
          icon: "fas fa-arrows-alt",
          href: "/console/my-leads",
          roles: [C.ROLE.ADMIN, C.ROLE.LEAD_SUPPLIER],
        },
        {
          title: "My Notifications",
          icon: "fa-solid fa-envelope",
          href: "/console/my-notifications",
          roles: [
            C.ROLE.ADMIN,
            C.ROLE.AGENT_ENGAGEMENT,
            C.ROLE.BROKERAGE_ADMIN,
            C.ROLE.MANAGER,
            C.ROLE.CSR_SUPERVISOR,
          ],
        },
        {
          title: "My Announcements",
          icon: "fa-solid fa-message-exclamation",
          href: "/console/my-announcements",
          roles: [
            C.ROLE.ADMIN,
            C.ROLE.AGENT_ENGAGEMENT,
            C.ROLE.BROKERAGE_ADMIN,
            C.ROLE.MANAGER,
            C.ROLE.CSR_SUPERVISOR,
          ],
        },
        {
          title: "My Admins",
          icon: "fa-solid fa-user-shield",
          href: "/console/my-admins",
          roles: [
            C.ROLE.ADMIN,
            C.ROLE.AGENT_ENGAGEMENT,
            C.ROLE.BROKERAGE_ADMIN,
          ],
        },
        {
          title: "My Metrics",
          icon: "fa-solid fa-chart-mixed",
          href: "/console/my-metrics",
          roles: [
            C.ROLE.ADMIN,
            C.ROLE.AGENT_ENGAGEMENT,
            C.ROLE.BROKERAGE_ADMIN,
          ],
        },
        {
          title: "Marketplace",
          icon: "fa-solid fa-shop",
          href: "/console/marketplace",
          chip: "",
          roles: [
            C.ROLE.ADMIN,
            C.ROLE.AGENT_ENGAGEMENT,
            C.ROLE.BROKERAGE_ADMIN,
          ],
        },
      ],
      adminNavItems: [
        {
          title: "Brokers",
          icon: "fas fa-user-tie",
          href: "/console/brokerages",
          roles: [
            C.ROLE.ADMIN,
            C.ROLE.MANAGER,
            C.ROLE.QA_TEAM,
            C.ROLE.CSR_SUPERVISOR,
            C.ROLE.AGENT_ENGAGEMENT,
          ],
        },
        {
          title: "Agents",
          icon: "fas fa-user-friends",
          href: "/console/agents",
          roles: [
            C.ROLE.ADMIN,
            C.ROLE.MANAGER,
            C.ROLE.QA_TEAM,
            C.ROLE.CSR_SUPERVISOR,
            C.ROLE.AGENT_ENGAGEMENT,
          ],
        },
        {
          title: "Lenders",
          icon: "fas fa-money-bill",
          href: "/console/lenders",
          roles: [
            C.ROLE.ADMIN,
            C.ROLE.MANAGER,
            C.ROLE.QA_TEAM,
            C.ROLE.CSR_SUPERVISOR,
            C.ROLE.AGENT_ENGAGEMENT,
            C.ROLE.LOAN_OFFICE_ADMIN,
          ],
        },
        {
          active: true,
          title: "Opp. Manager",
          icon: "fas fa-briefcase",
          roles: [
            C.ROLE.ADMIN,
            C.ROLE.MANAGER,
            C.ROLE.QA_TEAM,
            C.ROLE.CSR_SUPERVISOR,
            C.ROLE.AGENT_ENGAGEMENT,
            C.ROLE.CSR,
            C.ROLE.CSR_VIEW_OPPORTUNITIES,
          ],
          // href: "#",
          children: [],
          subRoutes: [
            {
              title: "Opportunities",
              icon: "",
              href: "/console/opportunities",
              roles: [
                C.ROLE.ADMIN,
                C.ROLE.MANAGER,
                C.ROLE.QA_TEAM,
                C.ROLE.CSR_SUPERVISOR,
                C.ROLE.AGENT_ENGAGEMENT,
                C.ROLE.CSR_VIEW_OPPORTUNITIES,
              ],
            },
            {
              title: "DNC List",
              icon: "",
              href: "/console/dnc-list",
              roles: [
                C.ROLE.ADMIN,
                C.ROLE.MANAGER,
                C.ROLE.QA_TEAM,
                C.ROLE.CSR_SUPERVISOR,
                C.ROLE.AGENT_ENGAGEMENT,
                C.ROLE.CSR,
              ],
            },
            {
              title: "Bulk SMS Send",
              icon: "",
              href: "/console/bulk-sms-send",
              roles: [
                C.ROLE.ADMIN,
                //C.ROLE.MANAGER,
                //C.ROLE.QA_TEAM,
                //C.ROLE.CSR_SUPERVISOR,
                //C.ROLE.AGENT_ENGAGEMENT,
                //C.ROLE.CSR,
              ],
            },
            // { icon: "", title: "Referrals", href: "/console/referrals" },
          ],
        },
        {
          title: "User Management",
          icon: "fas fa-users",
          href: "/console/user-management",
          roles: [C.ROLE.ADMIN, C.ROLE.MANAGER, C.ROLE.CSR_SUPERVISOR],
        },
        {
          title: "QA Review",
          icon: "fas fa-clipboard-list",
          href: "/console/qa-review",
          roles: [C.ROLE.ADMIN, C.ROLE.QA_TEAM],
        },
        {
          title: "Announcements",
          icon: "fa-solid fa-message-exclamation",
          href: "/console/announcements",
          roles: [C.ROLE.ADMIN, C.ROLE.QA_TEAM],
        },
        {
          active: true,
          title: "Diagnostic Tools",
          icon: "fas fa-tools",
          roles: [
            C.ROLE.ADMIN,
            C.ROLE.MANAGER,
            C.ROLE.CSR_SUPERVISOR,
            C.ROLE.AGENT_ENGAGEMENT,
            C.ROLE.CSR_VIEW_OPPORTUNITIES,
          ],
          // href: "#",
          children: [],
          subRoutes: [
            {
              title: "Agent Assignments",
              icon: "",
              href: "/console/agent-assignments",
              roles: [
                C.ROLE.ADMIN,
                C.ROLE.MANAGER,
                C.ROLE.CSR_SUPERVISOR,
                C.ROLE.AGENT_ENGAGEMENT,
              ],
            },
            {
              title: "Twilio Tasks",
              icon: "",
              href: "/console/twilio-tasks",
              roles: [
                C.ROLE.ADMIN,
                C.ROLE.MANAGER,
                C.ROLE.CSR_SUPERVISOR,
                C.ROLE.AGENT_ENGAGEMENT,
                C.ROLE.CSR_VIEW_OPPORTUNITIES,
              ],
            },
          ],
        },
        {
          active: true,
          title: "Dynamic Content",
          icon: "fas fa-sync",
          roles: [
            C.ROLE.ADMIN,
            C.ROLE.MANAGER,
            C.ROLE.CSR_SUPERVISOR,
            C.ROLE.AGENT_ENGAGEMENT,
          ],
          // href: "#",
          children: [],
          subRoutes: [
            {
              title: "Simulator",
              icon: "",
              href: "/console/simulator",
              roles: [
                C.ROLE.ADMIN,
                C.ROLE.MANAGER,
                C.ROLE.CSR_SUPERVISOR,
                C.ROLE.AGENT_ENGAGEMENT,
              ],
            },
            {
              title: "Content Search",
              icon: "",
              href: "/console/content-search",
              roles: [
                C.ROLE.ADMIN,
                C.ROLE.MANAGER,
                C.ROLE.CSR_SUPERVISOR,
                C.ROLE.AGENT_ENGAGEMENT,
              ],
            },
          ],
        },
        {
          title: "Supplier Management",
          icon: "fas fa-parachute-box",
          href: "/console/supplier-management",
          roles: [C.ROLE.ADMIN, C.ROLE.MANAGER, C.ROLE.CSR_SUPERVISOR],
        },
      ],
      agentNavItems: [
        {
          title: "Follow-ups",
          icon: "fa-regular fa-clock",
          href: "/console/agent-followups",
          exact: false,
          roles: [C.ROLE.AGENT],
        },
        {
          title: "My Funnel",
          icon: "fa-regular fa-filter",
          href: "/console/agent-funnel",
          chip: "",
          exact: false,
          roles: [C.ROLE.AGENT],
        },
        {
          title: "Profile",
          icon: "fa-regular fa-user",
          href: "/console/agent-profile",
          roles: [C.ROLE.AGENT],
        },
      ],

      // csrViewOppsNavItems: [
      //   {
      //     title: "Opportunities",
      //     icon: "",
      //     href: "/console/opportunities",
      //     roles: [
      //       C.ROLE.ADMIN,
      //       C.ROLE.MANAGER,
      //       C.ROLE.QA_TEAM,
      //       C.ROLE.CSR_SUPERVISOR,
      //       C.ROLE.AGENT_ENGAGEMENT,
      //       C.ROLE.CSR_VIEW_OPPORTUNITIES,
      //     ],
      //   },
      // ],
    };
  },
  watch: {
    impBrokerage() {
      this.brokerNavItems.forEach((nav) => {
        if (nav.title === "My Agents") {
          nav.chip = "";
        }
      });
      this.loadMyAgentCount();
    },
  },
  methods: {
    ...mapMutations("user", ["setDrawer", "toggleDrawer", "setUserType"]),
    reloadNav: function () {},
    titleClick() {
      // this.$router.push("/console");

      let role = this.roles[0];
      if (role in C.ROLE_DEFAULT_ROUTE) {
        this.$router.push(C.ROLE_DEFAULT_ROUTE[role]);
      } else {
        this.$router.push("console");
      }
    },
    childClick(navItem) {
      console.log(navItem);
    },
    async loadMyAgentCount() {
      try {
        let { resp } = await api.getAgents(0, 1, "name.last,asc", null);
        if (resp.data && resp.data.totalElements >= 0) {
          console.log(`total agents nav... ${resp.data.totalElements}`);
          this.brokerNavItems.forEach((nav) => {
            if (nav.title === "My Agents") {
              nav.chip = `${resp.data.totalElements}`;
            }
          });

          console.log("%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%");
          console.log(this.brokerNavItems);
        }
      } catch (e) {
        console.log(e);
      }
    },
    async loadMarketplaceViewCount() {
      console.log("loadMarketplaceViewCount");
      try {
        const params = {
          pageNumber: 0,
          pageSize: 10,
          viewed: true,
        };
        let resp = await api.user.getMarketplaceViewedItems(
          "marketplace",
          params,
        );
        console.log("=============getMarketplaceViewedItems===============");
        console.log(resp);
        console.log("=============getMarketplaceViewedItems===============");

        if (resp.data && resp.data.totalElements >= 0) {
          console.log(`total marketplaces ... ${resp.data.totalElements}`);
          this.brokerNavItems.forEach((nav) => {
            if (nav.title === "Marketplace") {
              if (resp.data.totalElements === this.existentMarketplaceCount) {
                this.viewedMarketplaceCount = resp.data.totalElements;
                nav.chip = "";
              } else {
                nav.chip = `${this.existentMarketplaceCount - resp.data.totalElements}`;
                // nav.chip = "5"; // hardcoded 4 as we have hardcoded marketplaces
              }
            }
          });

          console.log("%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%");
          console.log(this.resp.data);
        }
      } catch (e) {
        console.log(e);
      }
    },
    chipColor(title) {
      return title === "Marketplace" ? "red" : "default";
    },
    async clearChipCount() {
      // backwards logic as until you PUT those to viewed=true, they dont exist.
      // skipping updating viewed status for impersonations, only allow to put for broker admins
      if (this.viewedMarketplaceCount === 0 && this.isBrokerAdmin) {
        // currently hardcoded
        let marketplaceList = [
          "apination",
          "rialto",
          "broker-boost",
          "iris",
          "luxury-presence",
        ];
        marketplaceList.forEach((marketplace) => {
          let data = {
            item: marketplace,
            location: "marketplace",
            viewed: true,
          };
          this.updateMarketplace(data.location, data.item, data);
        });
        this.viewedMarketplaceCount = 5;
        this.brokerNavItems.forEach((nav) => {
          if (nav.title === "Marketplace") {
            // clear the chip we assume all the requests went through fine.
            nav.chip = "";
          }
        });
      }
    },
    updateMarketplace(location, item, data) {
      api.user
        .updateMarketplaceViewedStatus(location, item, data)
        .then((resp) => {
          console.log(resp);
        })
        .catch((e) => {
          this.errorCheck(e);
          console.error(e);
        })
        .finally(() => {});
    },
    async loadAppVersion() {
      this.iOSVersion = "N/A";
      this.androidVersion = "N/A";

      try {
        let { data } = await api.agent.getAppVersion();

        let iosApp = data.find((d) => {
          return d.env === "PROD" && d.deviceType === "IOS";
        });
        if (iosApp) {
          this.iOSVersion = iosApp.version;
        }

        let androidApp = data.find((d) => {
          return d.env === "PROD" && d.deviceType === "ANDROID";
        });
        if (androidApp) {
          this.androidVersion = androidApp.version;
        }
      } catch (e) {
        console.log(e);
      }
    },
  },
  computed: {
    ...mapGetters("user", [
      "me",
      "roles",
      "isAdmin",
      "isBrokerAdmin",
      "isLoanOfficer",
      "isAgent",
      "myAgentsCount",
      "brokerageHasProduct",
    ]),
    ...mapGetters("auth", [
      "impBrokerage",
      "impUser",
      "impLoanOffice",
      "impBrokerageHasProduct",
    ]),
    inputValue: {
      get() {
        return this.$store.state.user.drawer;
      },
      set(val) {
        this.setDrawer(val);
      },
    },
    navItems() {
      //user is loan officer or impersonating a loan officer AKA lender
      if (this.isLoanOfficer || this.impLoanOffice !== null) {
        console.log("we got a LoanOfficer");
        return this.lenderNavItems.filter((nav) => {
          // validate this user has the roles for the nav item
          if (
            this.roles.filter((r) => nav.roles.indexOf(r) !== -1).length > 0
          ) {
            this.setUserType("Lender");
            return nav;
          }
        });
      }

      // user is a brokerage admin or admin impersonating
      if (this.isBrokerAdmin || this.impBrokerage !== null) {
        return this.brokerNavItems.filter((nav) => {
          if (
            nav.title === "My Leads" &&
            this.brokerageHasProduct("LeadGenius")
          ) {
            return nav;
          }

          // validate this user has the roles for the nav item
          if (
            this.roles.filter((r) => nav.roles.indexOf(r) !== -1).length > 0
          ) {
            this.setUserType("Broker Admin");
            return nav;
          }
        });
      }

      if (this.isAgent) {
        return this.agentNavItems.filter((nav) => {
          // validate this user has the roles for the nav item
          if (
            this.roles.filter((r) => nav.roles.indexOf(r) !== -1).length > 0
          ) {
            this.setUserType("Agent");
            return nav;
          }
        });
      }

      return this.adminNavItems.filter((nav) => {
        // validate this user has the roles for the nav item
        if (this.roles.filter((r) => nav.roles.indexOf(r) !== -1).length > 0) {
          if (nav.subRoutes) {
            nav.children = nav.subRoutes.filter(
              (sr) =>
                this.roles.filter((r) => sr.roles.indexOf(r) !== -1).length > 0,
            );
          }
          this.setUserType("Admin");
          return nav;
        }
      });
    },
    supportEmail() {
      if (this.isAgent) {
        return "agentsupport@primestreet.io";
      }

      return "brokersupport@primestreet.io";
    },
  },
  mounted() {
    this.eventBus.$on(
      C.EVENT_BUS.CLEAR_MARKETPLACE_NOTIFICATION_COUNT,
      this.clearChipCount,
    );
    if (this.isBrokerAdmin || this.impBrokerage !== null) {
      this.loadMyAgentCount();
      this.loadMarketplaceViewCount();
    }

    this.loadAppVersion();
  },
  created() {},
  beforeUnmount() {
    this.eventBus.$off(
      C.EVENT_BUS.CLEAR_MARKETPLACE_NOTIFICATION_COUNT,
      this.clearChipCount,
    );
  },
  props: {},
  components: {},
};
</script>

<style scoped>
/*.v-list-item :deep(.v-list-item__append .v-icon) {*/
/*  font-size: 12px;*/
/*}*/

/*.list-container {*/
/*  margin-bottom: 96px;*/
/*}*/

/*.nav-drawer-list-group >>> .v-list-group__header {*/
/*  color: white !important;*/
/*}*/
</style>

<style scoped>
/*.v-list__item__action {*/
/*  justify-content: center !important;*/
/*  flex-direction: row !important;*/
/*}*/
.v-list-item :deep(.v-list-item__prepend i) {
  font-size: 20px;
}
.v-list-item :deep(.v-list-item__prepend .v-list-item__spacer) {
  width: 18px;
}
.v-list-item :deep(.v-list-item__append .v-icon) {
  font-size: 16px;
}
.v-list-item--active :deep(.v-list-item__overlay) {
  opacity: 0;
}
.v-list-item--active:hover :deep(.v-list-item__overlay) {
  opacity: 0;
}

/*.nav-active {*/
/*  color: #00c8a8 !important;*/
/*}*/

.terms-nav {
  color: #818181 !important;
  font-size: 12px;
  text-decoration: none;
}

.list-group-no-dividers:before,
.list-group-no-dividers:after {
  background: none !important;
}

.fixedBottom {
  position: fixed !important;
  bottom: 0 !important;
  width: 100%;
  background-color: #363636;
}

/*.nav-active {*/
/*  color: #00c8a8 !important;*/
/*}*/

.app-version-header {
  font-size: 13px;
  color: #b2b2b2;
}

.app-version {
  font-size: 12px;
  color: #b2b2b2;
}

/*:deep(.v-list-item__spacer) {*/
/*  width: 16px;*/
/*}*/

/*.active-list-item-no-overlay .v-list-item--active > .v-list-item__overlay,*/
/*.active-list-item-no-overlay*/
/*  .v-list-item[aria-haspopup="menu"][aria-expanded="true"]*/
/*  > .v-list-item__overlay {*/
/*  opacity: 0 !important; !* Override opacity *!*/
/*}*/
</style>
